import { render, staticRenderFns } from "./paymentAccount.vue?vue&type=template&id=2f1455cf&scoped=true"
import script from "./paymentAccount.vue?vue&type=script&lang=js"
export * from "./paymentAccount.vue?vue&type=script&lang=js"
import style0 from "./paymentAccount.vue?vue&type=style&index=0&id=2f1455cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1455cf",
  null
  
)

export default component.exports